import React, { Component } from 'react';
import addToMailchimp from 'gatsby-plugin-mailchimp'
import ReactGA from 'react-ga';
import * as moment from 'moment'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import './norway.css'
class AdventuresItem extends Component {

  componentDidMount() {
    this.setState({
      titleName: this.props.itemInfo.item.title
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      titleName: nextProps.title
    });
  }

  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      EMAIL: '',
      FNAME: '',
      DESCRIPTIO: '',
      messError: false,
      showmessage: '',
      titleName: '',
      successModal: false,
      checkbox: 'Subscribed',
      checkError: false,
      startDate: "",
      setStartDate: "",
      date: moment()
    }
    this._handleSubmit = this._handleSubmit.bind(this)
  }

  showModal = () => {
    this.setState({
      showModal: true
    })
  }

  closeModal = () => {
    this.setState({
      showModal: false
    })
  }
  handleChange = (e) => {
    e.preventDefault()
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  setStartDate = date => {
    let dateTime = moment(date).format('MM/DD/YYYY')
    this.setState({
      startDate: date,
      sendDate: dateTime
    });
  };

  handleCheckbox = (e) => {
    let checkBox = document.getElementById("gdpr_56345");
    if (checkBox.checked == true) {
      this.setState({
        checkbox: 'Subscribed'
      })
    } else {
      this.setState({
        checkbox: false
      })
    }
  }


  _handleSubmit(event) {
    event.preventDefault();
    let checkEmail = this.state.EMAIL
    if (checkEmail.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      if (this.state.FNAME !== '' && this.state.DESCRIPTIO !== '' && this.props.itemInfo.item.title !== undefined) {
        // let description = this.state.titleName + '-' + this.state.description
        // CHECKBOX
        addToMailchimp(this.state.EMAIL, {
          FNAME: this.state.FNAME,
          LNAME: this.props.itemInfo.item.title,
          PHONE: this.state.PHONE,
          DATETIME: this.state.startDate,
          TRAVELNUMB: this.state.TRAVELNUMB,
          DESCRIPTIO: this.state.DESCRIPTIO,
          CHECKBOX: this.state.checkbox
        }) // listFields are optional if you are only capturing the email address.
          .then(data => {
            // I recommend setting data to React state
            // but you can do whatever you want (including ignoring this `then()` altogether)
            this.setState({
              messError: false,
              showmessage: 'Thank you for your message. We will get back to you within 24 hrs.',
              successModal: true,
              showModal: false
            })
            return true
          })
          .catch((err) => {
            // unnecessary because Mailchimp only ever
            // returns a 200 status code
            // see below for how to handle errors
          })
        ReactGA.event({
          category: 'Destination Request',
          action: 'Book',
        });
      }
      else {
        this.setState({
          messError: true
        })
      }
    }
    else {
      this.setState({
        messError: true
      })
    }
  }

  confirmMessage = () => {
    this.setState({
      successModal: false
    })
  }
  render() {
    const { showModal } = this.state
    // const [startDate, setStartDate] = useState(new Date());
    return (
      <article className='adventures-item'>
        {showModal ?
          <div className='emailModal'>
            <div className="emailContainer">
              <div className='closeModal' onClick={this.closeModal}>x</div>
              <h2>Contact Detail. </h2>
              <div className="noticePara"><p>We need some contact information to confirm your request.</p></div>
              <form >
                <div className='form-group'>
                  <input type='text' onChange={(e) => this.handleChange(e)} name='FNAME' id="mce-FNAME" value={this.state.name} placeholder='Name' />
                </div>
                <div className='form-group'>
                  <input onChange={(e) => this.handleChange(e)} name='EMAIL' type='email' id="mce-EMAIL" placeholder='Email' />
                </div>

                <div className="multiple-col">
                  <div className='col'>


                    <div className='form-group'>
                      <input type='text' onChange={(e) => this.handleChange(e)} name='PHONE' id="mce-PHONE" placeholder='Phone Number' />
                    </div>

                  </div>

                  <div className='col'>
                    <div className='form-group'>
                      <input onChange={(e) => this.handleChange(e)} name='TRAVELNUMB' type='numberOfTravel' id="mce-TRAVELNUMB" placeholder='Number of Travelers' />
                    </div>
                  </div>
                </div>

                <div className='form-group'>
                  <textarea
                    onChange={(e) => this.handleChange(e)}
                    name='DESCRIPTIO'
                    id="mce=DESCRIPTIO"
                    placeholder='Enter Dates and any special requests..'></textarea>

                </div>
                <div id="mergeRow-gdpr" className="mergeRow gdpr-mergeRow content__gdprBlock mc-field-group">
                  <div className="content__gdpr">
                    <fieldset className="mc_fieldset gdprRequired mc-field-group" name="interestgroup_field">
                      <label className="checkbox subfield hidden-checkbox" htmlFor="gdpr_56333">
                        <input type="checkbox" id="gdpr_56333" name="gdpr[56333]" defaultChecked value="Y" className="av-checkbox " />
                        <span>Email</span>
                      </label>
                      <label className="checkbox subfield" htmlFor="gdpr_56345">
                        <input type="checkbox" id="gdpr_56345" onChange={this.handleCheckbox} defaultChecked name="gdpr[56345]" value="Y" className="av-checkbox " />
                        <span>Please check this box to hear about our upcoming trips.</span> </label>
                    </fieldset>
                    <p>Please click here for more information on our  <a href="/destinations/privacyPolicy/" target="_blank" rel="noopener noreferrer">Privacy practices</a></p>
                  </div>
                </div>
                {this.state.messError ? <span className="errormsg">Please check all fields</span> : null}
                {this.state.checkError ? <span>Please confirm with checkbox</span> : null}
                <div className="messInfo">{this.state.showmessage}</div>
                <div className='submitButton'><button onClick={this._handleSubmit}>Submit</button></div>
              </form>
            </div>

          </div> : null
        }
        {this.state.successModal ?
          <div className='emailModal'>
            <div className="successModal">
              Thank you for your message. We will get back to you within 24 hrs.
            <div onClick={this.confirmMessage} className='confirmBtn'>OK</div>
            </div>
          </div> : null}
        <div className='card'>
          <div className='imageInfo'>
            <a href={this.props.itemInfo.item.link} target="_blank" rel="noopener noreferrer"><img src={this.props.mainImage} alt='img1' className='main-img' /></a>
            <div className='review'>
              <div className='user'>
                <img src={this.props.itemInfo.item.guideImage} alt='User' />
              </div>
              <div className='rating'>
                <b>{this.props.itemInfo.item.userName}</b>
                {/* <ul>
                  <li>
                    <i className='fa fa-star' aria-hidden='true' /> {this.props.itemInfo.item.rating.stars}
                  </li>
                  <li>
                    <i className='fa fa-circle' aria-hidden='true' /> {this.props.itemInfo.item.rating.review} review
                  </li>
                  <li>
                    <i className='fa fa-circle' aria-hidden='true' /> {this.props.itemInfo.item.rating.adventures} adventures
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
          <div className='box'>
            <div className='status'>
              <span>{this.props.itemInfo.item.status.category}: </span>
              <span>{this.props.itemInfo.item.status.date}</span>
            </div>
            <h2>{this.props.itemInfo.item.title}</h2>
            <div className='place'>
              {/* <img src={location} alt='location' /> */}
              {this.props.itemInfo.item.location}
            </div>

            <div className='description'>

              <div className='place'>Departure dates: <b>{this.props.itemInfo.item.dates}</b></div>
              {/*
              <p>
                {this.props.itemInfo.item.description1}

                <a href={this.props.itemInfo.item.link} target="_blank" rel="noopener noreferrer">Click for Itinerary</a>
            
              </p>
                */}
               <a className='btn btn' href={this.props.itemInfo.item.link} target="_blank" rel="noopener noreferrer">See Itinerary</a>
             
            </div>
                
            <div className='shop'>
              <div className='regular-price'>
                <span>{this.props.itemInfo.item.show.regular_price}</span>
              </div>
              <div className='book-now p-0'>
                 <button
                  className='btn orange-btn'
                  onClick={() => this.showModal()}
                >
                  Make a Request
                </button> 
              </div>
        {/*      
              <div className='book-now p-0'>  
                <a className='btn orange-btn' href={this.props.itemInfo.item.link} target="_blank" rel="noopener noreferrer">See Itinerary</a>
              </div>
        */}
            </div>
              
          </div>
        </div>
      </article>
    );
  }
}



export default AdventuresItem;
